export default {
  // 修改密码 不能删除
  setPassword: {
    method: 'post',
    url: 'auth/password'
  },
  // 获取登录用户拥有的菜单 不能删除
  getMenus: {
    method: 'get',
    url: 'auth/menus/{id}'
  },
  // 获取登录用户拥有的权限  不能删除
  getFunc: {
    method: 'get',
    url: 'auth/func/{id}'
  },
  // 根据角色获取菜单与权限
  getMenusRole: {
    method: 'get',
    url: 'auth/menus/role'
  },
  // 根据用户获取菜单与权限
  getMenusUser: {
    method: 'get',
    url: 'auth/menus/user'
  },
  // 短信签名列表查询
  getAutoList: {
    method: 'get',
    url: 'message/signature/list'
  },
  // 模板审核接口
  templateAudit: {
    method: 'put',
    url: 'message/signature/review'
  },
  // 创建短信模板
  createTemplate: {
    method: 'post',
    url: 'message/template/'
  },
  // 修改短信模板
  changeTemplate: {
    method: 'put',
    url: 'message/template/'
  },
  // 单条模板删除接口
  deleteTemplate: {
    method: 'delete',
    url: 'message/template/{id}'
  },
  // 短信签名列表接口
  getAutographList: {
    method: 'get',
    url: 'message/signature/page'
  },
  // 查询q签名列表各类型数量
  getAutographTypeQuantity: {
    method: 'get',
    url: 'message/signature/count'
  },
  // 创建短信签名
  createMessageAutograph: {
    method: 'post',
    url: 'message/signature/'
  },
  // 修改短信签名
  changeMessageAutograph: {
    method: 'put',
    url: 'message/signature/'
  },
  // 删除短信签名
  deleteMessageAutograph: {
    method: 'delete',
    url: 'message/signature/{id}'
  },
  // 短信签名审核
  // RESOLVE encode query string
  autographCheck: {
    method: 'put',
    url: 'message/signature/review?id={id}&tenantId={tenantId}'
  },
  // 更新签名通过状态
  changeAutographTrueStatus: {
    method: 'put',
    url: 'message/signature/status/{id}?status={status}&tenantId={tenantId}',
    bodyType: 'smsSignatureStatusDTOS'
  },
  // 更新签名拒绝状态
  changeAutographFalseStatus: {
    method: 'put',
    url:
      'message/signature/status/{id}?status={status}&reason={reason}&tenantId={tenantId}',
    bodyType: 'array'
  },
  // 获取营销短信列表
  getMarketList: {
    method: 'get',
    url: 'message/job/campaign'
  },
  // 营销短信明细列表
  getMarketDetail: {
    method: 'get',
    url: 'message/job/campaign/detail'
  },
  // 营销短信明细列表下载
  getMarketDownload: {
    method: 'get',
    url: 'message/job/campaign/detail/download'
  },
  // 通知短信列表
  getNoticeList: {
    method: 'get',
    url: 'message/job/notice'
  },
  // 查询短信模板列表
  getTemplateList: {
    method: 'get',
    url: 'message/template/page'
  },
  // 获取当前模板关联品牌
  getRelationBrand: {
    method: 'get',
    url: 'message/template'
  },
  // 关联当前模板和品牌
  relationTemplate: {
    method: 'post',
    url:
      'message/template?tenantId={tenantId}&templateId={templateId}&brandIds={brandIds}'
  },
  // 查询模板列表各类型数量
  getTempTypeQuantity: {
    method: 'get',
    url: 'message/template/count'
  },
  // 模板提交审核接口
  templateCheck: {
    method: 'put',
    url: 'message/template/review?id={id}&tenantId={tenantId}'
  },
  // 更新模板通过状态
  changeTemplateTrueStatus: {
    method: 'put',
    url: 'message/template/status/{id}?status={status}&tenantId={tenantId}',
    bodyType: 'smsTemplateChannelDTOS'
  },
  // 更新模板拒绝状态
  changeTemplateFalseStatus: {
    method: 'put',
    url:
      'message/template/status/{id}?status={status}&reason={reason}&tenantId={tenantId}',
    bodyType: 'array'
  },
  // 当前月每日报告列表
  getReportMonth: {
    method: 'get',
    url: 'message/report/month'
  },
  // 统计一定范围内的短信报告
  getReportRange: {
    method: 'get',
    url: 'message/report/statistic'
  },
  // 获取短信签名不分页
  getAutrogroph: {
    method: 'get',
    url: 'message/signature/list'
  },
  // 获取系统通道列表
  getChannelList: {
    method: 'get',
    url: 'message/setting/channel'
  },
  // 添加通道
  addChangeChannel: {
    method: 'post',
    url: 'message/setting/channel'
  },
  // 获取模板参数列表
  getMessageParam: {
    method: 'get',
    url: 'variables'
  },
  // 新增修改变量数据
  changeParamInfo: {
    method: 'post',
    url: 'variables'
  },
  // 删除模板参数
  deleteParam: {
    method: 'delete',
    url: 'variables'
  },
  // 短信账户列表查询
  getAccountList: {
    method: 'get',
    url: 'accounts'
  },
  // 获取短信账户品牌列表
  getBrands: {
    method: 'get',
    url: 'accounts/brands'
  },
  // 修改短信账户状态
  changeAccoutStatus: {
    method: 'put',
    url:
      'accounts/status?tenantId={tenantId}&accountId={accountId}&status={status}'
  },
  // 新增或者编辑账户
  changeAccountInfo: {
    method: 'post',
    url: 'accounts'
  },
  // 获取账户详情接口
  accountDetail: {
    method: 'get',
    url: 'accounts/{id}'
  },
  // 获取短信通道列表
  messageChannel: {
    method: 'get',
    url: 'accounts/channels'
  },
  // 批量停用账户
  stopAccounts: {
    method: 'put',
    url: 'accounts?tenantId={tenantId}&accountIds={accountIds}'
  }
}
